module.exports = __webpack_public_path__ + "img/vertical-logo.45ebbf2a.png";